<script lang="ts" setup>
interface Props {
  color?: string
}

withDefaults(defineProps<Props>(), {
  color: '#433860'
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.7549 9.43262V17H11.1484V9.43262H12.7549ZM11.9619 6.53418C12.208 6.53418 12.4199 6.60026 12.5977 6.73242C12.7799 6.86458 12.8711 7.09245 12.8711 7.41602C12.8711 7.73503 12.7799 7.96289 12.5977 8.09961C12.4199 8.23177 12.208 8.29785 11.9619 8.29785C11.7067 8.29785 11.4902 8.23177 11.3125 8.09961C11.1393 7.96289 11.0527 7.73503 11.0527 7.41602C11.0527 7.09245 11.1393 6.86458 11.3125 6.73242C11.4902 6.60026 11.7067 6.53418 11.9619 6.53418Z"
      :fill="color"
    />
  </svg>
</template>
